<template>
  <div class="row no-wrap">
    <SampleGroupList
      class="full-height self-strentch"
      style="width: 200px; flex-shrink: 0"
    />
    <SampleGroupSampleList
      class="full-height self-strentch"
      style="width: 600px;flex-shrink: 0"
    />
    <SampleGroupSampleDistribution class="full-height self-strentch col-grow" />
  </div>
</template>

<script>
export default {
  components: {
    SampleGroupList: () => import("./SampleGroupList"),
    SampleGroupSampleList: () => import("./SampleGroupSampleList"),
    SampleGroupSampleDistribution: () =>
      import("./SampleGroupSampleDistribution"),
  },
};
</script>
